import { lazy } from 'react';
import Loadable from 'components/Loadable';
import ErrorPage from 'views/Error';

const AuthLogin = Loadable(lazy(() => import('views/auth/login/Login')));

const AuthRoutes = {
  path: '/',
  errorElement: <ErrorPage />,
  children: [
    {
      path: '/login',
      element: <AuthLogin />
    }
  ]
};

export default AuthRoutes;
